$(document).ready(function(){
    $('a[href="https://greeneryunlimited.co/blogs/plant-care/tagged/common-questions"]').attr('aria-label', 'Browse common plant care questions');

$('a[href="https://greeneryunlimited.co/blogs/plant-care/tagged/tools-techniques"]').attr('aria-label', 'Browse plant care tools and techniques');

$('a[href="https://greeneryunlimited.co/blogs/plant-care/tagged/pest-management"]').attr('aria-label', 'Browse pest management articles');

$('a[href="https://greeneryunlimited.co/pages/plant-care"], a[href="/pages/plant-care"]').attr('aria-label', 'View plant care guide');

$('a[href="/pages/about"]').attr('aria-label', 'Learn about Greenery Unlimited');

$('a[href="/collections/large-containers"]').attr('aria-label', 'Shop large plant containers');

$('a[href="/collections/small-containers"]').attr('aria-label', 'Shop small plant containers');

$('a[href="/collections/tools-accessories"]').attr('aria-label', 'Shop plant tools and accessories');

$('a[href="/products/grow-light-sansi-15w"]').attr('aria-label', 'View Sansi 15W grow light');

$('a[href="/blogs/plant-care"]').attr('aria-label', 'Read plant care blog');

$('a[href="https://twitter.com/greeneryny"]').attr('aria-label', 'Visit Greenery Unlimited on Twitter');

$('a[href="https://www.facebook.com/greeneryunlimited/"]').attr('aria-label', 'Visit Greenery Unlimited on Facebook');

$('a[href="https://www.pinterest.com/greeneryunlimitedco"]').attr('aria-label', 'Visit Greenery Unlimited on Pinterest');

$('a[href="https://www.instagram.com/greeneryunlimited/?hl=en"]').attr('aria-label', 'Visit Greenery Unlimited on Instagram');

$('a[href="javascript:void(0);"].hide.close-main-menu')
    .attr('aria-label', 'Close main menu');

$('div.scrollup a')
    .attr('aria-label', 'Scroll to top');

    $('input.input-search.animation').attr('aria-label', 'Search');

$('input[type="email"][name="contact[email]"]').attr('aria-label', 'Enter your email address');

  $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/icon_user.svg?v=236292842263026941780611400\"]").attr("alt", "Icon User");
    $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/logo_min.svg?v=116866791312549354491780611400\"]").attr("alt", "Logo Min");
    $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/icon_explore.svg?v=55862047064747256521780611400\"]").attr("alt", "Icon Explore");
    $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/icon_user.svg?v=236292842263026941780611400\"]").attr("alt", "Icon User");
 $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/icon_close_menu.svg?v=25016844282885254721780611400\"]").attr("alt", "left arrow");
 $('div.item.slick-slide.slick-current').removeAttr('aria-describedby');
$("div.item_gallery.slick-slide").removeAttr('aria-describedby');

    $('input.searchBox.field[name="q"]').attr('aria-label', 'Search');
    $("a.blog-menu-search").attr("aria-label","Blog search");

setTimeout(() => {
  
     $('div#thumbs div.item_gallery.slick-slide').removeAttr('aria-describedby');
     $('a[href="/blogs/plant-care/aglaonema-care"]').attr('aria-label', 'Read Aglaonema plant care guide');
     

     $('a[href="/products/milton-41-ol"]').attr('aria-label', 'Milton 41');
     $('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/55b04893300b--Milton-41-4534.041-WH-Philodendron-Hope-Selloum-10-6feaef_400x400_crop_center.jpg?v=1613512294"]').attr('alt', 'Milton 41 planter with Philodendron Hope Selloum plant');
$('a[href="/pages/alocasia-care"]').attr('aria-label', 'Read Alocasia plant care guide');
$('a[href="/blogs/plant-care/anthurium-care"]').attr('aria-label', 'Read Anthurium plant care guide');
$('a[href="/blogs/plant-care/birdsnest-fern"]').attr('aria-label', 'Read Birds Nest Fern care guide');
$('a[href="/pages/bird-of-paradise-care"]').attr('aria-label', 'Read Bird of Paradise care guide');
$('a[href="/pages/cactus-care"]').attr('aria-label', 'Read Cactus care guide');
$('a[href="/blogs/plant-care/calathea-care"]').attr('aria-label', 'Read Calathea plant care guide');
$('a[href="/pages/dieffenbachia-care"]').attr('aria-label', 'Read Dieffenbachia care guide');
$('a[href="/pages/dracaena-compacta-care"]').attr('aria-label', 'Read Dracaena Compacta care guide');
$('a[href="/pages/lemon-lime-dracaena-care"]').attr('aria-label', 'Read Lemon Lime Dracaena care guide');
$('a[href="/pages/dracaena-lisa-cane-care"]').attr('aria-label', 'Read Dracaena Lisa Cane care guide');
$('a[href="/pages/dracaena-tarzan-care"]').attr('aria-label', 'Read Dracaena Tarzan care guide');
$('a[href="/pages/ficus-alli-care"]').attr('aria-label', 'Read Ficus Alii care guide');
$('a[href="/blogs/plant-care/ficus-audrey-care"]').attr('aria-label', 'Read Ficus Audrey care guide');
$('a[href="/pages/rubber-plant-care"]').attr('aria-label', 'Read Rubber Plant care guide');
$('a[href="/pages/ficus-elastica-ruby-care"]').attr('aria-label', 'Read Ficus Elastica Ruby care guide');
$('a[href="/pages/fiddle-leaf-fig-care"]').attr('aria-label', 'Read Fiddle Leaf Fig care guide');
$('a[href="/pages/ficus-moclame-care"]').attr('aria-label', 'Read Ficus Moclame care guide');
$('a[href="/pages/natal-mahogany-care"]').attr('aria-label', 'Read Natal Mahogany care guide');
$('a[href="/pages/neanthe-bella-palm-care"]').attr('aria-label', 'Read Neanthe Bella Palm care guide');
$('a[href="/blogs/plant-care/monstera-deliciosa-care"]').attr('aria-label', 'Read Monstera Deliciosa care guide');
$('a[href="/pages/pencil-cactus-care"]').attr('aria-label', 'Read Pencil Cactus care guide');
$('a[href="/blogs/plant-care/peperomia-care"]').attr('aria-label', 'Read Peperomia plant care guide');
$('a[href="/blogs/plant-care/philodendron-cordatum-care"]').attr('aria-label', 'Read Philodendron Cordatum care guide');
$('a[href="/pages/philodendron-hope-care"]').attr('aria-label', 'Read Philodendron Hope care guide');
$('a[href="/pages/philodendron-prince-of-orange-care"]').attr('aria-label', 'Read Philodendron Prince of Orange care guide');
$('a[href="/pages/pilea-peperomioides-care"]').attr('aria-label', 'Read Pilea Peperomioides care guide');
$('a[href="/pages/ponytail-palm-care"]').attr('aria-label', 'Read Ponytail Palm care guide');
$('a[href="/blogs/plant-care/pothos-care"]').attr('aria-label', 'Read Pothos plant care guide');
$('a[href="/pages/rhipsalis-care"]').attr('aria-label', 'Read Rhipsalis care guide');
$('a[href="/blogs/plant-care/sansevieria-care"]').attr('aria-label', 'Read Sansevieria plant care guide');
$('a[href="/pages/sansevieria-bantels-sensation-care"]').attr('aria-label', "Read Sansevieria Bantel's Sensation care guide");
$('a[href="/pages/schefflera-amate-care"]').attr('aria-label', 'Read Schefflera Amate care guide');
$('a[href="/blogs/plant-care/senecio-care"]').attr('aria-label', 'Read Senecio plant care guide');
$('a[href="/pages/string-of-hearts-care"]').attr('aria-label', 'Read String of Hearts care guide');
$('a[href="/pages/variegated-monstera-care"]').attr('aria-label', 'Read Variegated Monstera care guide');
$('a[href="/pages/zz-care"]').attr('aria-label', 'Read ZZ Plant care guide');
$('a[href="/blogs/plant-care/kentia-palm-care"]').attr('aria-label', 'Read Kentia Palm care guide');

$('a[href="https://greeneryunlimited.co/collections/tools-accessories/products/aeration-stones"]')
    .attr('aria-label', 'View Aeration Stones product');

$('a[href="https://amzn.to/3ZYUBeP"]')
    .attr('aria-label', 'View ARS pruning shears on Amazon');

$('a[href="https://amzn.to/3YHoyPE"]')
    .attr('aria-label', 'View Neem Oil plant treatment on Amazon');

$('a[href="https://greeneryunlimited.co/products/brass-soil-probe"]')
    .attr('aria-label', 'View Brass Soil Probe product');

$('a[href="https://amzn.to/3ZUnPvn"]')
    .attr('aria-label', 'View Stainless Steel Watering Can on Amazon');

$('a[href="https://amzn.to/423XaOy"]')
    .attr('aria-label', 'View FoxFarm Ocean Forest Potting Soil on Amazon');

$('a[href="https://amzn.to/3J6ddmv"]')
    .attr('aria-label', 'View Plant Grow Light on Amazon');

$('a[href="https://amzn.to/3ZD6NlY"]')
    .attr('aria-label', 'View Cork Plant Mats on Amazon');

    $('a.thumb.color-swatch-white').attr('aria-label', 'Select white color');

$('a.thumb.color-swatch-slate').attr('aria-label', 'Select slate color');

$('a.thumb.color-swatch-black').attr('aria-label', 'Select black color');

$('a.thumb.color-swatch-black').attr('aria-label', 'Select black color');

$('a.thumb.color-swatch-travertine').attr('aria-label', 'Select travertine color');

$('a.thumb.color-swatch-stone').attr('aria-label', 'Select stone color');
$('div.item_gallery.slick-slide').removeAttr('aria-describedby');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/55b04893300b--Milton-41-4534.041-WH-Philodendron-Hope-Selloum-10-6feaef_400x400_crop_center.jpg?v=1613512294"]').attr('alt', 'Milton 41 planter with Philodendron Hope Selloum plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ab62bef4769c--Calyer-34-1945.034-WH-Bird-of-Paradise-10-e622fa_400x400_crop_center.jpg?v=1613487708"]').attr('alt', 'Calyer 34 planter with Bird of Paradise plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ab62bef4769c--Wythe-30-2970.030-SA-Bird-of-Paradise-10-273feb_400x400_crop_center.jpg?v=1613508527"]').attr('alt', 'Wythe 30 planter with Bird of Paradise plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ab62bef4769c--Wythe-40-2970.040-TE-Bird-of-Paradise-14-feab29_400x400_crop_center.jpg?v=1613508608"]').attr('alt', 'Wythe 40 planter with Bird of Paradise plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ab62bef4769c--Newel-30-9360.030-ST-Bird-of-Paradise-10-ca58e6_400x400_crop_center.jpg?v=1613559709"]').attr('alt', 'Newel 30 planter with Bird of Paradise plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/3736a51648c5--Franklin-12-P-C-FRA12-WH-59c5a5c8-4a42-4033-9035-762dcad4e4d0-d30bd5_400x400_crop_center.jpg?v=1615819179"]').attr('alt', 'Franklin 12 planter in white');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/3736a51648c5--Ainslie-17-P-C-AIN17-TE-f05ecaab-6064-4518-8224-a9a8874868f0-af5b1c_400x400_crop_center.jpg?v=1615819236"]').attr('alt', 'Ainslie 17 planter in terracotta');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/5ce372fd24cd--Sutton-15-P-C-SUT15-WH-787c5650-6efe-4002-b54a-961c848adec5-af0141_400x400_crop_center.jpg?v=1615819693"]').attr('alt', 'Sutton 15 planter in white');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/5ce372fd24cd--Milton-41-4534.041-WH-Monstera-Deliciosa-10-f4ee22_400x400_crop_center.jpg?v=1613562210"]').attr('alt', 'Milton 41 planter with Monstera Deliciosa plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/5ce372fd24cd--Wythe-30-2970.030-SA-Monstera-Deliciosa-10-89bb0d_400x400_crop_center.jpg?v=1613562262"]').attr('alt', 'Wythe 30 planter with Monstera Deliciosa plant');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/5ce372fd24cd--Huron-50-8245.050-BL-83016117-2d32-4bff-8e0b-ab9573d87537-c07169_400x400_crop_center.jpg?v=1613562298"]').attr('alt', 'Huron 50 planter in black');
}, 1000);

$("h4:empty").append("<span style='display:none'>.</span>");
$('a[href="/collections/containers/products/kent-48-ol"]').attr('aria-label', 'View Kent 48 planter');
$('a[href="/collections/containers/products/newel-30"]').attr('aria-label', 'View Newel 30 planter');
$('a[href="/collections/containers/products/saucer-14-ol"]').attr('aria-label', 'View Saucer 14 planter saucer');
$('a[href="/collections/containers/products/saucer-10-ol"]').attr('aria-label', 'View Saucer 10 planter saucer');
$('a[href="/collections/containers/products/franklin-17"]').attr('aria-label', 'View Franklin 17 planter');
$('a[href="/collections/containers/products/sutton-15"]').attr('aria-label', 'View Sutton 15 planter');
$('a[href="/collections/containers/products/varick-20"]').attr('aria-label', 'View Varick 20 planter');
$('a[href="/collections/containers/products/franklin-12"]').attr('aria-label', 'View Franklin 12 planter');
$('a[href="/collections/containers/products/fondra"]').attr('aria-label', 'View Fondra planter');
$('a[href="/collections/containers/products/lorimer-30-large-planter"]').attr('aria-label', 'View Lorimer 30 large planter');
$('a[href="/collections/containers/products/bedford-30-ol"]').attr('aria-label', 'View Bedford 30 planter');
$('a[href="/collections/containers/products/devoe-15"]').attr('aria-label', 'View Devoe 15 planter');
$('a[href="/collections/containers/products/prospect-planter"]').attr('aria-label', 'View Prospect planter');
$('a[href="/collections/containers/products/astor-planter"]').attr('aria-label', 'View Astor planter');
$('a[href="/collections/containers/products/calyer-46-large-planter-copy"]').attr('aria-label', 'View Calyer 46 large planter');
$('a[href="/collections/containers/products/wythe"]').attr('aria-label', 'View Wythe planter');
$('a[href="/collections/containers/products/milton-41"]').attr('aria-label', 'View Milton 41 planter');
   $("img[src=\"//greeneryunlimited.co/cdn/shop/t/56/assets/soldout.png?v=94839167971018989111780611400\"]").attr("alt", "Grey lines crossing over each other");
$("img[src=\"//greeneryunlimited.co/cdn/shop/files/bedford-30-ol-white.png?v=1776718480\"]").attr("alt", "Large white cylindrical planter on gray surface");
$("img[src=\"https://cdn.shopify.com/s/files/1/0013/3529/6118/files/Greenery-Unlimited-Trust-the-Experts.jpg?v=1591901825\"]").attr("alt", "Greenery filled indoor seating area with table and chairs");
$("img[src=\"https://cdn.shopify.com/s/files/1/0013/3529/6118/files/Family-Owned-and-Operated_fc2b17e2-af33-4e89-a868-9b21b862d5a6.jpg?v=1614464693\"]").attr("alt", "Founders Adam & Rebecca holding hands in plant-filled room");
if (!$("img#large-thumb").attr("alt") || $("img#large-thumb").attr("alt").trim() === "") {
    $("img#large-thumb").attr("alt", "Product image");
}
$('a[href="//greeneryunlimited.co/cdn/shop/files/gallery_prospect-planters.png?v=1781914548"]').attr('aria-label', 'View Prospect planters image');
$('a[href="/collections/small-containers/products/sutton-15"]').attr('aria-label', 'View Sutton 15 planter');

$('a[href="/collections/small-containers/products/franklin-12"]').attr('aria-label', 'View Franklin 12 planter');

$('a[href="/collections/small-containers/products/franklin-17"]').attr('aria-label', 'View Franklin 17 planter');

$('a[href="/collections/small-containers/products/varick-20"]').attr('aria-label', 'View Varick 20 planter');

$('a[href="/collections/small-containers/products/fondra"]').attr('aria-label', 'View Fondra planter');

$('a[href="/collections/small-containers/products/devoe-15"]').attr('aria-label', 'View Devoe 15 planter');


$('a[href="/collections/large-containers/products/bedford-30-ol"]').attr('aria-label', 'View Bedford 30 planter');
$('a[href="/collections/large-containers/products/newel-30"]').attr('aria-label', 'View Newel 30 planter');
$('a[href="/collections/large-containers/products/lorimer-30-large-planter"]').attr('aria-label', 'View Lorimer 30 large planter');
$('a[href="/collections/large-containers/products/saucer-14-ol"]').attr('aria-label', 'View Saucer 14 planter saucer');
$('a[href="/collections/large-containers/products/saucer-10-ol"]').attr('aria-label', 'View Saucer 10 planter saucer');
$('a[href="/collections/large-containers/products/kent-48-ol"]').attr('aria-label', 'View Kent 48 planter');
$('a[href="/collections/large-containers/products/prospect-planter"]').attr('aria-label', 'View Prospect planter');
$('a[href="/collections/large-containers/products/astor-planter"]').attr('aria-label', 'View Astor planter');
$('a[href="/collections/large-containers/products/calyer-46-large-planter-copy"]').attr('aria-label', 'View Calyer 46 large planter');
$('a[href="/collections/large-containers/products/wythe"]').attr('aria-label', 'View Wythe planter');
$('a[href="/collections/large-containers/products/milton-41"]').attr('aria-label', 'View Milton 41 planter');
$("img[src=\"//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/4ff4251ec942--Sutton.png?v=1611145331\"]").attr("alt", "Technical drawing of a cylindrical object with dimensions");

$('a.thumb[href="javascript:void(0);"][data-pot-handle][data-color]').each(function () {
    var $this = $(this);
    var product = $this.attr('data-pot-handle') || '';
    var color = $this.attr('data-color') || '';
    
    product = product.replace(/-/g, ' ').replace(/\b\w/g, function (l) {
        return l.toUpperCase();
    });

    var label = 'Select ' + product + ' planter in ' + color;

    if ($this.hasClass('sold-out')) {
        label += ' (sold out)';
    }

    if ($this.hasClass('active')) {
        label += ' (selected)';
    }

    $this.attr('aria-label', label);
});

$('a[rel="photoswipe"]').attr('aria-label', 'Open product image in gallery');
$("img[src=\"//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/2405acb76414--Franklin-17.png?v=1611145625\"]").attr("alt", "Technical drawing of cylindrical object dimensions");

$("img[src=\"//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/275743264afa--DIMENSIONAL-DRAWING-Newel-30.png?v=1607638380\"]").attr("alt", "Technical drawing of a tapered cup with dimensions");

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/1ee47667193b--7cb7dbff23c3-DIMENSIONAL-DRAWING-Kent-48_Large 48.png?v=1606244689"]').attr('alt', 'Dimensional drawing of Kent 48 large planter');

$("img[src=\"//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/5c810746eb2b--MEASUREMENTS-Milton-41.png?v=1587910471\"]").attr("alt", "Dimensional drawing of Milton 41 large planter");

$("h3:empty").append("<span style='display:none'>.</span>");
$("img[src^='//greeneryunlimited.co/cdn/shop/t/56/assets/icon_search.svg']").attr("alt","Search icon");
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
 $('div#thumbs div.item_gallery.slick-slide').removeAttr('aria-describedby');
$('img[src^="//greeneryunlimited.co/cdn/shop/t/56/assets/icon_cart.svg?"]').attr('alt', 'Shopping cart icon');
$('img[src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg"]').attr('alt', 'Google Translate icon');
   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/files/ezgif-1-0b1a32ce8ad1.gif?v=1569592978"]').attr('alt', 'Illustration showing plant light requirements');

$('input[name="email"]').attr('aria-label', 'Enter your email address');

$('input[name="customer[password]"]').attr('aria-label', 'Enter your password');

$('input[name="customer[email]"]').attr('aria-label', 'Enter your email address');
$("h4>strong:empty").append("<span style='display:none'>.</span>");

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/b0b01a2f018e--Sutton-15-P-C-SUT15-SA-6a9648e3-e5a7-459b-924a-6d41cfaac0c6-56ecf0_400x400_crop_center.jpg?v=1615729895"]').attr('alt', 'Sutton 15 planter in pale salmon');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/b0b01a2f018e--Ainslie-17-P-C-AIN17-TE-8a120074-8e44-45b3-8f4a-9d5a9e404cac-26ba75_400x400_crop_center.jpg?v=1615729985"]').attr('alt', 'Ainslie 17 planter in terracotta');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/b0b01a2f018e--Varick-20-P-C-VAR20-BL-90cf8022-8016-4789-bce3-7f3942a66f06-307b39_400x400_crop_center.jpg?v=1615730048"]').attr('alt', 'Varick 20 planter in matte black');
  $("img[src=\"https://cdn.shopify.com/s/files/1/0013/3529/6118/files/image_123927839.JPG?v=1596828225\"]").attr("alt", "Hand holding large green leaf with yellowing edges");

  $('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ec95ef87fc10--Franklin-12-P-C-FRA12-WH-176eaf97-1ebc-483d-9a65-18acb2ef4e67-2cf298_400x400_crop_center.jpg?v=1615818433"]').attr('alt', 'Franklin 12 planter in white');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ec95ef87fc10--Sutton-15-P-C-SUT15-SA-e761ce84-6e04-4d32-b868-fd9487209896-ee8779_400x400_crop_center.jpg?v=1615818453"]').attr('alt', 'Sutton 15 planter in pale salmon');

$('img[src="//cdn.shopify.com/s/files/1/0013/3529/6118/t/24/assets/ec95ef87fc10--Ainslie-17-P-C-AIN17-TE-138b2ca1-e3fc-48da-86fb-8f62f029691f-e4bf5b_400x400_crop_center.jpg?v=1615818473"]').attr('alt', 'Ainslie 17 planter in terracotta');
console.log("ready");
});
